"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IBboxFromJS = exports.IBbox = void 0;
var utils_1 = require("../../../utils");
var default_label_1 = require("../../default-values/default-label");
var id_type_1 = require("../id-type");
exports.IBbox = (0, utils_1.IRecord)({
    id: id_type_1.defaultId,
    rect: (0, utils_1.IRect)(),
    label: default_label_1.defaultLabel
});
var IBboxFromJS = function (bboxJS) {
    return (0, exports.IBbox)({
        id: bboxJS.id,
        label: bboxJS.label,
        rect: (0, utils_1.IRect)(bboxJS.rect)
    });
};
exports.IBboxFromJS = IBboxFromJS;
